import { useLocation } from "react-router-dom";
import {
  useMrReceiptQuery,
  usePyReceiptQuery,
} from "../../features/api/transactionApi";
import numberToWords from "number-to-words";
import headerLogo from "../../asset/johura_logo.png";
import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
} from "@react-pdf/renderer";
import { PDFViewer } from "@react-pdf/renderer";
import { bankList } from "../../data";

const styles = StyleSheet.create({
  page: {
    // backgroundColor: "white",
    // paddingBottom: "88pt",
    backgroundColor: "#fff",
    padding: "0.7cm",
  },
  header: {
    // display:'flex',
    // flexDirection:'column',
    // justifyContent:'space-between',
    // alignItems:'center'
    // marginBottom: 5,
    // textAlign: "center",
    // height: "3.8cm",
  },

  footerAddr: {
    fontSize: "9px",
    textAlign: "center",
    width: "55%",
    margin: " auto",
    // width: "100%",
    // fontWeight: "thin",
  },
});

const ReceiptSup = () => {
  const location = useLocation();
  const state = location?.state;

  const pyReceipt = usePyReceiptQuery(state, {
    refetchOnMountOrArgChange: true,
  })?.data;

  // function for formated date
  function formatDate(dateString) {
    const date = new Date(dateString);
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    let getDate = day + "-" + month + "-" + year;
    return getDate;
  }

  return (
    <div>
      <div className="w-full lg:max-w-[1280px] px-6 lg:px-auto mx-auto h-[90vh] overflow-auto">
        <PDFViewer style={{ width: "100%", height: "100%" }}>
          <Document>
            <Page size="A5" orientation="landscape" style={styles.page}>
              {/* Header */}
              <View style={styles.header}>
                <View>
                  <View style={{ width: "60%", margin: "auto" }}>
                    <Image
                      src={headerLogo}
                      style={{ height: "20px", marginBottom: "5px" }}
                    />
                  </View>
                  <View style={styles.footerAddr}>
                    <Text>
                      15/A Zigatola, Hafizullah Green Tower, Flat # C1,
                      Dhanmondi, Dhaka - 1209
                    </Text>
                    <Text>
                      Cell: 01711-071102, 01977-071102, 01778-874364, E-mail:
                      jahangirjohura@gmail.com / Web: www.johurabd.com
                    </Text>
                  </View>
                </View>
              </View>

              {/* Money Receipt */}
              <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: "10px",
                  alignItems: "center",
                  fontSize: "12px",
                }}
              >
                <Text style={{ backgroundColor: "" }}>
                  PY No.: {pyReceipt?.mr_no}
                </Text>
                <View style={{ padding: "2px", backgroundColor: "black" }}>
                  <Text
                    style={{
                      color: "white",
                      padding: "4px",
                      border: "1px solid white",
                      fontWeight: "",
                    }}
                  >
                    MONEY RECEIPT
                  </Text>
                </View>
                <Text style={{ backgroundColor: "" }}>
                  PY Date: {formatDate(pyReceipt?.mr_date)}
                </Text>
              </View>

              {/* Body */}
              <View
                style={{
                  flexDirection: "column",
                  gap: "10px",
                  marginTop: "10px",
                }}
              >
                <View
                  style={{
                    fontSize: "12px",
                    flexDirection: "row",
                    alignItems: "center",
                    marginTop: "10px",
                  }}
                >
                  <Text style={{ width: "25%" }}>
                    Received with thanks from
                  </Text>
                  <Text
                    style={{
                      borderBottom: "1px solid dotted",
                      borderStyle: "dotted",
                      width: "75%",
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    {pyReceipt?.supplier}
                  </Text>
                </View>
                <View
                  style={{
                    fontSize: "12px",
                    flexDirection: "row",
                    alignItems: "center",
                    marginTop: "10px",
                  }}
                >
                  <Text style={{ width: "3%" }}>Of</Text>
                  <Text
                    style={{
                      borderBottom: "1px solid dotted",
                      borderStyle: "dotted",
                      width: "97%",
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: "13px",
                    }}
                  >
                    JOHURA
                  </Text>
                </View>
                <View
                  style={{
                    fontSize: "12px",
                    flexDirection: "row",
                    alignItems: "center",
                    marginTop: "10px",
                  }}
                >
                  <Text style={{ width: "12%" }}>Sum of Taka</Text>
                  <Text
                    style={{
                      borderBottom: "1px solid dotted",
                      borderStyle: "dotted",
                      width: "88%",
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: "13px",
                      textTransform: "capitalize",
                    }}
                  >
                    {typeof pyReceipt?.dabit_amount !== "number" ||
                    !isFinite(pyReceipt?.dabit_amount)
                      ? "error"
                      : numberToWords.toWords(pyReceipt?.dabit_amount)}{" "}
                    Taka Only
                  </Text>
                </View>
                <View
                  style={{
                    fontSize: "12px",
                    flexDirection: "row",
                    alignItems: "center",
                    marginTop: "10px",
                  }}
                >
                  <Text style={{ width: "32%" }}>
                    as a Payment againest the bill No
                  </Text>
                  <Text
                    style={{
                      borderBottom: "1px solid dotted",
                      borderStyle: "dotted",
                      width: "43%",
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: "13px",
                    }}
                  >
                    {pyReceipt?.narr}
                  </Text>
                  <Text style={{ width: "5%" }}>Date</Text>
                  <Text
                    style={{
                      borderBottom: "1px solid dotted",
                      borderStyle: "dotted",
                      width: "20%",
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: "13px",
                    }}
                  >
                    {pyReceipt?.inv_date
                      ? formatDate(pyReceipt?.inv_date)
                      : null}
                  </Text>
                </View>
                <View
                  style={{
                    fontSize: "12px",
                    flexDirection: "row",
                    alignItems: "center",
                    marginTop: "10px",
                  }}
                >
                  {/* <Text style={{ width: "15%" }}>Cash/Cheque</Text> */}
                  <Text
                    style={{
                      borderBottom: "1px solid dotted",
                      borderStyle: "dotted",
                      width: "20%",
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: "13px",
                    }}
                  >
                    {pyReceipt?.p_method}
                  </Text>
                  <Text style={{ width: "5%" }}>Date</Text>
                  <Text
                    style={{
                      borderBottom: "1px solid dotted",
                      borderStyle: "dotted",
                      width: "15%",
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: "13px",
                    }}
                  >
                    {pyReceipt?.chq_date
                      ? formatDate(pyReceipt?.chq_date)
                      : null}
                  </Text>
                  <Text style={{ width: "5%" }}>Bank</Text>
                  <Text
                    style={{
                      borderBottom: "1px solid dotted",
                      borderStyle: "dotted",
                      width: "55%",
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: "13px",
                    }}
                  >
                    {bankList?.find((bank) => bank?.id == pyReceipt?.bank_id)
                      ?.name || null}
                  </Text>
                </View>
                <View
                  style={{
                    marginTop: "10px",
                    fontSize: "12px",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <Text>Tk</Text>
                  <Text
                    style={{
                      border: "1px solid gray",
                      // padding: "4px",
                      width: "120px",
                      textAlign: "center",
                      height: "25px",
                      paddingTop: "6px",
                      fontSize: "14px",
                    }}
                  >
                    {pyReceipt?.dabit_amount}
                  </Text>
                </View>
              </View>

              {/* Footer */}
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "flex-end",
                  fontSize: "12px",
                  marginTop: "40px",
                }}
              >
                <Text style={{ fontStyle: "italic" }}>
                  This Receipt is valid subject to realisation
                </Text>
                <Text style={{ fontStyle: "italic" }}>
                  For Johura Endomed Solution
                </Text>
              </View>
            </Page>
          </Document>
        </PDFViewer>
      </div>
    </div>
  );
};

export default ReceiptSup;
